// extracted by mini-css-extract-plugin
export default {"bellIcon":"MessageCenterMenu__bellIcon__L2sAi","GlobalNav__BellIcon":"MessageCenterMenu__GlobalNav__BellIcon__QkO4V"};